const returnMonthlyAmount = (amount, paymentInterval) => {
    const monthlyAmount = paymentInterval === 'month' ? amount : amount / 12
    return monthlyAmount.toFixed(0)
}

const normalizePrice = (amount, currency, addOnsTotalPrice = "0") => {
    const parsedAmount = parseFloat(amount) || 0
    const parsedAddOns = parseFloat(addOnsTotalPrice) || 0

    const price = (Math.abs(parsedAmount) + parsedAddOns) / 100

    if (!currency) {
        return price
    }

    return currency + price.toFixed(2)
}

export default {
    returnMonthlyAmount,
    normalizePrice
}
